<template>
  <div id="app">
    <section class="dashboard">
      <div class="container">
        <div class="dashboard__content">
          <DashboardActions />
          <div class="panel" data-animate data-animation-classes="animated pulse">
            <img class="panel__logo" src="./assets/img/logo.png" alt="Nowodworski Estates">
            <router-view/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
@import "assets/scss/main";
  .dashboard {
    background-image: url("assets/img/background2.jpg");
  }
</style>
<script>
  import DashboardActions from "./components/DashboardActions";
  export default {
    components: {DashboardActions}
  }
</script>